<template>
  <b-card
    title="مراحل دریافت درگاه پرداخت"
    sub-title="جهت ایجاد درگاه پرداخت بانکی مراحل زیر را در کمتر از ۵ دقیقه بگذرانید"
    sub-title-tag="p"
    sub-title-text-variant="dark"
  >
    <b-card-group v-if="!loading" deck class="pt-5">
      <!-- <b-col cols="12" md="6" sm="6" lg="3"> -->
      <b-card no-body bg-variant="light">
        <b-card-body>
          <div class="mb-2">
            <b-skeleton animation="throb" width="25%"></b-skeleton>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <b-skeleton animation="throb" width="50%"></b-skeleton>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class="">
              <b-skeleton type="avatar"></b-skeleton>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <b-skeleton animation="throb" width="75%"></b-skeleton>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>
      <b-col cols="12" md="6" sm="6" lg="3"> -->
      <b-card no-body bg-variant="light">
        <b-card-body>
          <div class="mb-2">
            <b-skeleton animation="throb" width="25%"></b-skeleton>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <b-skeleton animation="throb" width="50%"></b-skeleton>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class="">
              <b-skeleton type="avatar"></b-skeleton>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <b-skeleton animation="throb" width="75%"></b-skeleton>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>
      <b-col cols="12" md="6" sm="6" lg="3"> -->
      <b-card no-body bg-variant="light">
        <b-card-body>
          <div class="mb-2">
            <b-skeleton animation="throb" width="25%"></b-skeleton>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <b-skeleton animation="throb" width="50%"></b-skeleton>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class="">
              <b-skeleton type="avatar"></b-skeleton>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <b-skeleton animation="throb" width="75%"></b-skeleton>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>
      <b-col cols="12" md="6" sm="6" lg="3"> -->
      <b-card no-body bg-variant="light">
        <b-card-body>
          <div class="mb-2">
            <b-skeleton animation="throb" width="25%"></b-skeleton>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <b-skeleton animation="throb" width="75%"></b-skeleton>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class="">
              <b-skeleton type="avatar"></b-skeleton>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <b-skeleton animation="throb" width="75%"></b-skeleton>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>     -->
    </b-card-group>
    <!-- <b-row class="pt-5 align-items-center"> -->
    <b-card-group v-else deck class="pt-5">
      <!-- <b-col cols="12" md="6" sm="6" lg="3"> -->
      <b-card no-body bg-variant="light" title="مرحله اول" title-tag="p">
        <b-card-body>
          <div class="mb-2">
            <span class="text-muted font-size-sm">مرحله اول</span>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <span class="text-bold"> ثبت نام </span>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class=""
              ><b-icon
                scale="1.5"
                variant="success"
                icon="check-circle-fill"
              ></b-icon
            ></b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <p class="pb-0 mb-0 font-size-sm">
                ثبت نام با شماره موبایل و ایمیل
              </p>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>
      <b-col cols="12" md="6" sm="6" lg="3"> -->
      <b-card
        :class="className == 'information' ? className : null"
        no-body
        bg-variant="light"
      >
        <b-card-body>
          <div class="mb-2">
            <span class="text-muted font-size-sm">مرحله دوم</span>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <span
                :class="
                  nationnalCode == '' ? 'text-bold text-primary' : 'text-bold'
                "
                variant="primary"
              >
                اطلاعات کاربری
              </span>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class="d-flex flex-end">
              <b-link v-if="nationnalCode == ''">
                <b-icon
                  @click="$router.push('information')"
                  scale="1.5"
                  variant="primary"
                  icon="arrow-left-circle-fill"
                ></b-icon>
              </b-link>
              <!-- <b-icon
                v-else
                scale="1.5"
                variant="success"
                icon="check-circle-fill"
              ></b-icon> -->
              <b-link
                v-else-if="
                  (statusAuth == 2 || statusAuth == 4) && nationnalCode != ''
                "
              >
                <b-icon
                  class="ml-4"
                  @click="
                    $router.push({
                      path: '/information',
                      query: { status: 'edit' },
                    })
                  "
                  scale="1.5"
                  variant="primary"
                  icon="pencil-square"
                ></b-icon>
              </b-link>
              <b-icon
                scale="1.5"
                variant="success"
                icon="check-circle-fill"
                v-else-if="statusAuth == 3"
              >
              </b-icon>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <p v-if="nationnalCode == ''" class="pb-0 mb-0 font-size-sm">
                وارد کردن اطلاعات کاربری
              </p>
              <p
                v-else-if="
                  (statusAuth == 2 || statusAuth == 4) && nationnalCode != ''
                "
                class="pb-0 mb-0 font-size-sm text-primary"
              >
                اطلاعات کاربری قابل ویرایش می باشد.
              </p>
              <p v-else-if="statusAuth == 3" class="pb-0 mb-0 font-size-sm">
                اطلاعات کاربری تایید شد
              </p>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>
      <b-col cols="12" md="6" sm="6" lg="3"> -->
      <b-card
        :class="className == 'authentication' ? className : null"
        no-body
        bg-variant="light"
      >
        <b-card-body>
          <div class="mb-2">
            <span class="text-muted font-size-sm">مرحله سوم</span>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <span class="text-bold"> احراز هویت </span>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class="d-flex flex-end">
              <b-link v-if="statusAuth == 2">
                <b-icon
                  @click="$router.push('authentication')"
                  scale="1.5"
                  variant="primary"
                  icon="pencil-square"
                ></b-icon>
              </b-link>
              <b-icon
                v-else-if="statusAuth == 0 || nationnalCode == ''"
                scale="1.5"
                icon="arrow-left-circle-fill"
                variant="secondary"
              ></b-icon>
              <b-icon
                v-else-if="statusAuth == 3"
                scale="1.5"
                variant="success"
                icon="check-circle-fill"
              ></b-icon>
              <b-link
                v-else-if="
                  (statusAuth == 1 || statusAuth == 4) && nationnalCode != ''
                "
              >
                <b-icon
                  @click="$router.push('authentication')"
                  scale="1.5"
                  icon="arrow-left-circle-fill"
                  variant="primary"
                ></b-icon
              ></b-link>

              <b-link v-else>
                <b-icon
                  @click="$router.push('authentication')"
                  scale="1.5"
                  variant="primary"
                  icon="eye-fill"
                ></b-icon>
              </b-link>
            </b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <p
                v-if="
                  (statusAuth == 1 || statusAuth == 4) && nationnalCode != ''
                "
                class="pb-0 mb-0 font-size-sm text-primary"
              >
                بارگذاری مدارک
              </p>
              <p
                v-else-if="statusAuth == 2"
                class="pb-0 mb-0 font-size-sm text-primary"
              >
                در انتظار تایید مدارک
              </p>
              <p v-else-if="statusAuth == 3" class="pb-0 mb-0 font-size-sm">
                مدارک تایید شد
              </p>
              <p
                v-else-if="statusAuth == 0 || nationnalCode == ''"
                class="pb-0 mb-0 font-size-sm"
              >
                ارسال مدارک
              </p>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>
      <b-col cols="12" md="6" sm="6" lg="3"> -->
      <addGateway></addGateway>
      <b-card
        :class="className == 'bussines' && statusAuth == 3 ? className : null"
        no-body
        bg-variant="light"
      >
        <b-card-body>
          <div class="mb-2">
            <span class="text-muted font-size-sm">مرحله چهارم</span>
          </div>
          <b-row align-v="center" class="d-flex justify-content-between">
            <b-col cols="10" md="9" sm="10">
              <span class="text-bold"> کسب و کار و درگاه </span>
            </b-col>
            <!-- <b-col cols="12" md="auto"></b-col> -->
            <b-col cols="2" md="3" sm="2" class="d-flex flex-end">
              <b-link
                v-if="
                  nationalStatus == 1522 &&
                  phoneStatus == 1522 &&
                  selfieStatus == 1522 &&
                  licenseStatus == 1522
                "
              >
                <b-icon
                  v-b-modal.add-gateway-modal
                  scale="1.5"
                  variant="primary"
                  icon="arrow-left-circle-fill"
                ></b-icon>
              </b-link>
              <b-icon
                v-else
                scale="1.5"
                icon="arrow-left-circle-fill"
                variant="secondary"
              ></b-icon
            ></b-col>
          </b-row>
          <b-row
            align-v="center"
            class="justify-content-md-center pb-0 mb-0 mt-2"
          >
            <b-col>
              <p class="pb-0 mb-0 font-size-sm">
                ثبت نام با شماره موبایل یا ایمیل
              </p>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <!-- </b-col>     -->
    </b-card-group>
    <!-- </b-row> -->
  </b-card>
</template>

<script>
import { GETUSER } from "@/core/services/store/getUser.module";
import sessionHelper from "../../helpers/sessionHelper.js";
import httpHelper from "../../helpers/httpHelper";
import addGateway from "@/pages/PaymentGateway/addGatewaymodal.vue";

export default {
  name: "",
  props: ["className"],
  components: {
    addGateway
  },
  data() {
    return {
      nationnalCode: "",
      phoneStatus: null,
      nationalStatus: null,
      selfieStatus: null,
      paymentGateway: "",
      licenseStatus: null,
      statusAuth: 0,
      timer: null,
      value: null,
      loading: false,
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.value = 25 + this.value;
    }, 1000);
    this.loading = false;
    this.$store.dispatch(GETUSER).then((data) => {
      this.loading = true;
      this.nationnalCode = data.national_card_number;
      this.nationalStatus = data.nationalstatus;
      this.phoneStatus = data.phonestatus;
      this.selfieStatus = data.selfiestatus;

      !data.licenseStatus &&
      this.nationalStatus == 1522 &&
      this.phoneStatus == 1522 &&
      this.selfieStatus == 1522
        ? (this.licenseStatus = 1522)
        : null;

      !data.licenseStatus &&
      this.nationalStatus == 1521 &&
      this.phoneStatus == 1522 &&
      this.selfieStatus == 1521
        ? (this.licenseStatus = 1521)
        : null;

      !data.licenseStatus &&
      this.nationalStatus == 1520 &&
      this.phoneStatus == 1520 &&
      this.selfieStatus == 1520
        ? (this.licenseStatus = 1520)
        : null;
      //  data.licenseStatus ?  this.licenseStatus=data.licenseStatus : this.licenseStatus=1521;
      //       if (!data.licenseStatus && this.nationalStatus==1522 && this.phoneStatus==1522 && this.selfieStatus==1522) {
      //         this.licenseStatus=1522;
      //       }
      let route = this.$route.query.from;
      if (
        this.nationalStatus == 1520 &&
        this.phoneStatus == 1520 &&
        this.selfieStatus == 1520 &&
        this.licenseStatus == 1520 &&
        route === "new"
      ) {
        this.statusAuth = 0;
      } else if (
        (this.nationalStatus == 1520 ||
          this.phoneStatus == 1520 ||
          this.selfieStatus == 1520 ||
          this.licenseStatus == 1520) &&
        route != undefined &&
        route != "information" &&
        route != "authentication"
      ) {
        this.statusAuth = 1;
      } else if (
        this.nationalStatus == 1521 &&
        this.selfieStatus == 1521 &&
        this.licenseStatus == 1521
      ) {
        this.statusAuth = 2;
      } else if (
        this.nationalStatus == 1522 &&
        this.phoneStatus == 1522 &&
        this.selfieStatus == 1522 &&
        this.licenseStatus == 1522
      ) {
        this.statusAuth = 3;
      } else if (
        (this.nationalStatus == 1520 ||
          this.selfieStatus == 1520 ||
          this.phoneStatus == 1520 ||
          this.nationalStatus == 1521 ||
          this.selfieStatus == 1521 ||
          this.licenseStatus == 1520 ||
          this.licenseStatus == 1521) &&
        route != "new"
      ) {
        this.statusAuth = 4;
      } else {
        this.statusAuth = -1;
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {},
};
</script>

<style>
.steps {
  min-width: 220px;
  width: calc(25% - 12px);
  height: 105px;
  border-radius: 4px;
  padding: 16px;
  border: 1px solid #d8e2ef;
  border-top: 0.5px solid #d8e2ef;
  font-family: Vazir FD;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  outline: none;
  color: #4d5969;
  margin: 0 0 16px 16px;
}
/* .shake {
  animation: shake-animation 4.27s ease infinite;
  transform-origin: 50% 50%;
  animation-name: shake-animation;
  -webkit-animation-iteration-count: 4;
  -moz-animation-iteration-count: 4;
  animation-iteration-count: infinite;
}
@keyframes shake-animation {
  0% {
    transform: translate(0, 0);
  }
  1.78571% {
    transform: translate(5px, 0);
  }
  3.57143% {
    transform: translate(0, 0);
  }
  5.35714% {
    transform: translate(5px, 0);
  }
  7.14286% {
    transform: translate(0, 0);
  }
  8.92857% {
    transform: translate(5px, 0);
  }
  10.71429% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(0, 0);
  }
} */
.face1 {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
.information {
  animation: shake 3.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
.authentication {
  animation: shake 5.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
.bussines {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>